// Shared input state read by 3D components inside useFrame (no re-renders).
// Mouse in -1..1 normalized viewport coords. Drag velocity in radians/frame.

const state = {
  mx: 0,
  my: 0,
  tmx: 0, // target mouse (smoothed)
  tmy: 0,
  dragVx: 0,
  dragVy: 0,
  dragging: false,
  bootTime: typeof performance !== "undefined" ? performance.now() : 0,
};

export const inputStore = {
  get: () => state,
  setMouse: (x, y) => {
    state.mx = x;
    state.my = y;
  },
  setDrag: (vx, vy) => {
    state.dragVx = vx;
    state.dragVy = vy;
  },
  setDragging: (d) => {
    state.dragging = d;
  },
};

// Utility: initialize global mouse listener
export function initInputListeners() {
  if (typeof window === "undefined") return () => {};
  const onMove = (e) => {
    const nx = (e.clientX / window.innerWidth) * 2 - 1;
    const ny = -((e.clientY / window.innerHeight) * 2 - 1);
    inputStore.setMouse(nx, ny);
  };
  window.addEventListener("pointermove", onMove, { passive: true });
  return () => window.removeEventListener("pointermove", onMove);
}
